import { render, staticRenderFns } from "./Cooperation.vue?vue&type=template&id=b2af3206&scoped=true&"
import script from "./Cooperation.vue?vue&type=script&lang=js&"
export * from "./Cooperation.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Cooperation.vue?vue&type=style&index=0&id=b2af3206&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b2af3206",
  "adb25f98"
  
)

component.options.__file = "Cooperation.vue"
export default component.exports